/* Way B store behaviour. Hooks are data-* attributes set by the Liquid. Cart and search go through Shopify's real endpoints. */
(function () {
  'use strict';
  var W = window.WB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem('wb-' + k)); sessionStorage.setItem('wb-' + k, JSON.stringify(v)); } catch (e) { return null; } }

  /* ---------- countdown: a per-visitor window kept in sessionStorage; restarts at zero (see README) ---------- */
  if (W.hours > 0) {
    var win = W.hours * 3600 * 1000, end = store('deadline');
    if (!end || end < Date.now()) { end = Date.now() + win; store('deadline', end); }
    var tick = function () {
      var left = end - Date.now();
      if (left <= 0) { end = Date.now() + win; store('deadline', end); left = win; }
      var h = Math.floor(left / 3600000), m = Math.floor(left / 60000) % 60, s = Math.floor(left / 1000) % 60;
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      $$('[data-t="h"]').forEach(function (e) { e.textContent = p(h); });
      $$('[data-t="m"]').forEach(function (e) { e.textContent = p(m); });
      $$('[data-t="s"]').forEach(function (e) { e.textContent = p(s); });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- sliders: arrows, dots, mouse drag ---------- */
  function slider(wrap) {
    var rail = $('[data-rail]', wrap); if (!rail || rail.wbSlider) return;
    rail.wbSlider = true;
    var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap), dots = $('[data-dots]', wrap);
    function step() { var c = rail.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) : 300; }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (dots) {
      dots.innerHTML = Array.prototype.map.call(rail.children, function (_, i) { return '<button type="button" aria-label="' + (i + 1) + '"></button>'; }).join('');
      $$('button', dots).forEach(function (b, i) { b.addEventListener('click', function () { rail.scrollTo({ left: rail.children[i].offsetLeft - rail.children[0].offsetLeft, behavior: 'smooth' }); }); });
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      if (dots) {
        var i = Math.round(rail.scrollLeft / Math.max(1, step())); if (rail.scrollLeft >= max) i = rail.children.length - 1;
        $$('button', dots).forEach(function (b, k) { b.classList.toggle('on', k === i); });
      }
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync); setTimeout(sync, 60);
    var down = false, x0 = 0, s0 = 0, moved = false;
    rail.addEventListener('mousedown', function (e) { if (e.button) return; down = true; moved = false; x0 = e.pageX; s0 = rail.scrollLeft; });
    window.addEventListener('mouseup', function () { down = false; rail.classList.remove('drag'); });
    rail.addEventListener('mousemove', function (e) {
      if (!down) return; var d = e.pageX - x0;
      if (!moved && Math.abs(d) > 6) { moved = true; rail.classList.add('drag'); }
      if (moved) rail.scrollLeft = s0 - d;
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  $$('[data-slider]').forEach(slider);

  /* ---------- layers: bag, search, menu, popups ---------- */
  function openLayer(id) {
    var el = document.getElementById(id); if (!el) return;
    el.hidden = false; requestAnimationFrame(function () { el.classList.add('open'); });
    document.documentElement.classList.add('lock');
  }
  function closeLayer(el) { el.classList.remove('open'); document.documentElement.classList.remove('lock'); setTimeout(function () { el.hidden = true; }, 260); }
  var more = $('.hdr-more');
  function moreToggle(on) { if (!more) return; more.classList.toggle('open', on); more.querySelector('button').setAttribute('aria-expanded', on ? 'true' : 'false'); }
  if (more) {
    moreToggle(false);
    more.querySelector('button').addEventListener('click', function (e) { e.stopPropagation(); moreToggle(!more.classList.contains('open')); });
    document.addEventListener('click', function (e) { if (!more.contains(e.target)) moreToggle(false); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.layer.open').forEach(closeLayer); moreToggle(false); } });

  /* ---------- predictive search ---------- */
  var si = $('#search input[type="search"]'), sr = $('#search [data-results]'), srDefault = sr ? sr.innerHTML : '', srTimer, srSeq = 0;
  if (si && sr) {
    si.addEventListener('input', function () {
      clearTimeout(srTimer);
      var q = si.value.trim(); var seq = ++srSeq;
      if (!q) { sr.innerHTML = srDefault; return; }
      srTimer = setTimeout(function () {
        fetch(W.routes.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (seq !== srSeq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html'), inner = $('[data-results-inner]', doc);
            if (inner) sr.innerHTML = inner.innerHTML;
          }).catch(function () {});
      }, 200);
    });
  }

  /* ---------- bag: Shopify's AJAX cart + Section Rendering; every total comes back rendered by Shopify ---------- */
  var busy = false;
  function paintCart(sections) {
    var html = sections && sections['cart-drawer']; if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('#cart', doc), cur = $('#cart'); if (!fresh || !cur) return;
    $('.panel', cur).innerHTML = $('.panel', fresh).innerHTML;
    cur.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    var n = +fresh.getAttribute('data-items') || 0;
    $$('[data-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
    $$('[data-slider]', cur).forEach(slider);
  }
  function post(url, body) {
    body.sections = ['cart-drawer']; body.sections_url = location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fail(err, node) {
    var msg = err && (err.description || err.message);
    if (!msg) return;
    var box = node && node.parentNode ? node.parentNode.querySelector('.err') : null;
    if (!box && node && node.parentNode) { box = document.createElement('p'); box.className = 'err'; box.setAttribute('role', 'alert'); node.parentNode.insertBefore(box, node.nextSibling); }
    if (box) box.textContent = msg;
  }
  function addVariant(id, qty, node) {
    if (busy) return Promise.reject(); busy = true;
    return post(W.routes.add, { items: [{ id: +id, quantity: qty || 1 }] })
      .then(function (j) { busy = false; paintCart(j.sections); return j; })
      .catch(function (e) { busy = false; fail(e, node); throw e; });
  }
  function changeLine(key, qty) {
    if (busy) return; busy = true;
    post(W.routes.change, { id: key, quantity: qty })
      .then(function (j) { busy = false; if (location.pathname === W.routes.cart) { location.reload(); return; } paintCart(j.sections); })
      .catch(function () { busy = false; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]');
    if (o) { e.preventDefault(); openLayer(o.getAttribute('data-open')); if (o.getAttribute('data-open') === 'search') setTimeout(function () { if (si) si.focus(); }, 80); return; }
    var c = t.closest('[data-close]');
    if (c) { closeLayer(c.closest('.layer')); return; }
    if (t.classList && t.classList.contains('layer')) { closeLayer(t); return; }
    var a = t.closest('[data-add]');
    if (a) { e.preventDefault(); var stay = a.hasAttribute('data-stay'); addVariant(a.getAttribute('data-add'), 1, a).then(function () { if (!stay) openLayer('cart'); }, function () {}); return; }
    var l = t.closest('[data-line]');
    if (l) { changeLine(l.getAttribute('data-line'), +l.getAttribute('data-qty')); return; }
  });
  document.addEventListener('change', function (e) {
    var cb = e.target.closest && e.target.closest('[data-care]'); if (!cb) return;
    if (cb.checked) addVariant(cb.getAttribute('data-care'), 1).catch(function () { cb.checked = false; });
    else changeLine(cb.getAttribute('data-care-line'), 0);
  });

  /* ---------- welcome popup ---------- */
  var pop = $('#mystery');
  if (pop) {
    if (pop.hasAttribute('data-open-now')) openLayer('mystery');
    else if (!store('welcome-seen')) setTimeout(function () { openLayer('mystery'); store('welcome-seen', 1); }, 2600);
    $$('[data-why]', pop).forEach(function (b) { b.addEventListener('click', function () { pop.setAttribute('data-step', '2'); var i = $('input[type="email"]', pop); if (i) i.focus(); }); });
  }

  /* ---------- accordions: one open at a time inside a group ---------- */
  $$('[data-acc-group]').forEach(function (g) {
    $$('details', g).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) $$('details', g).forEach(function (o) { if (o !== d) o.open = false; }); }); });
  });

  /* ---------- product page ---------- */
  var form = $('[data-buy-form]');
  if (!form) return;
  var variants = JSON.parse($('[data-variants]').textContent);
  var gal = $('[data-gallery]'), th = $('[data-thumbs]');

  function showImage(i) {
    var fig = gal.children[i]; if (!fig) return;
    var ov = getComputedStyle(gal).overflowX;
    if (ov === 'auto' || ov === 'scroll') gal.scrollTo({ left: fig.offsetLeft - gal.children[0].offsetLeft, behavior: 'smooth' });
    else $$('.gi', gal).forEach(function (f, k) { f.classList.toggle('on', k === i); });
    if (th) $$('button', th).forEach(function (o, k) { o.classList.toggle('on', k === i); });
  }
  if (th) {
    $$('button', th).forEach(function (b, i) { b.addEventListener('click', function () { showImage(i); }); });
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
      $$('button', th).forEach(function (o, k) { o.classList.toggle('on', k === i); });
      var n = $('[data-gal-n]'); if (n) n.textContent = (i + 1) + ' / ' + gal.children.length;
      var b = $$('button', th)[i];
      if (b && th.scrollWidth > th.clientWidth + 2) th.scrollTo({ left: b.offsetLeft - th.offsetLeft - (th.clientWidth - b.clientWidth) / 2, behavior: 'smooth' });
    }, { passive: true });
  }

  /* variant picker */
  var soldLabel = $('[data-atc-label]').getAttribute('data-sold');
  var addLabel = $('[data-atc-label]').getAttribute('data-add-label');
  function currentOptions() {
    var out = [];
    $$('[data-option]', form).forEach(function (s) { out[+s.getAttribute('data-option')] = s.value; });
    $$('[data-option-fixed]', form).forEach(function (s) { out[+s.getAttribute('data-option-fixed')] = s.textContent; });
    return out;
  }
  function applyVariant() {
    var want = currentOptions();
    var v = variants.filter(function (x) { return x.options.join('|') === want.join('|'); })[0];
    var ok = !!(v && v.available);
    $$('[data-atc-label]').forEach(function (l) { l.textContent = ok ? addLabel : soldLabel; });
    $$('[data-atc-main],[data-atc-sticky]').forEach(function (b) { b.disabled = !ok; });
    if (!v) return;
    $('[data-variant-id]', form).value = v.id;
    $$('[data-price]').forEach(function (e) { e.textContent = v.price; });
    $$('[data-price-compare]').forEach(function (e) { e.textContent = v.compare; e.hidden = !v.compare; });
    var box = $('.stk'), st = $('[data-stock]');
    if (st) { st.hidden = !v.stock; $('span', st).innerHTML = v.stock; }
    if (box) box.hidden = !v.stock && !$('[data-ship]', box);
    if (v.img) { var fig = $('.gi[data-img="' + v.img + '"]', gal); if (fig) showImage(Array.prototype.indexOf.call(gal.children, fig)); }
    try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); } catch (e) {}
  }
  $$('[data-option]', form).forEach(function (s) { s.addEventListener('change', applyVariant); });

  /* ship date: business days counted from today */
  if (W.shipDays > 0) {
    var ship = new Date(), days = W.shipDays;
    while (days) { ship.setDate(ship.getDate() + 1); if (ship.getDay() % 6) days--; }
    $$('[data-ship]').forEach(function (e) { e.textContent = ship.toLocaleDateString(W.locale || undefined, { weekday: 'long', month: 'long', day: 'numeric' }); });
  }

  /* customer videos: muted while in view, tap one for sound */
  var cvs = $$('.cv');
  var play = function (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); };
  if (cvs.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { var v = $('video', x.target); if (x.intersectionRatio >= 0.6) play(v); else v.pause(); });
    }, { threshold: [0, 0.6] });
    cvs.forEach(function (c) { io.observe(c); });
  }
  cvs.forEach(function (c) {
    var v = $('video', c);
    $('button', c).addEventListener('click', function () {
      var on = !c.classList.contains('on');
      cvs.forEach(function (o) { if (o !== c) { o.classList.remove('on'); $('video', o).muted = true; } });
      c.classList.toggle('on', on); v.muted = !on;
      if (on) v.currentTime = 0;
      play(v);
    });
  });

  /* add to bag, then the one-time add-on offer if there is one, then the bag */
  var offer = $('#offer'), offerTimer = null;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    addVariant($('[data-variant-id]', form).value, 1, $('[data-atc-main]', form)).then(function () {
      if (offer && !store('offer-seen')) { store('offer-seen', 1); openOffer(); } else openLayer('cart');
    }, function () {});
  });
  function openOffer() {
    openLayer('offer');
    var mins = +offer.getAttribute('data-minutes') || 0, t = $('[data-offer-t]', offer);
    if (!mins || !t) return;
    var stop = Date.now() + mins * 60000;
    clearInterval(offerTimer);
    offerTimer = setInterval(function () {
      var s = Math.max(0, Math.round((stop - Date.now()) / 1000));
      t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    }, 250);
  }
  if (offer) {
    $$('[data-offer-img]', offer).forEach(function (b) {
      b.addEventListener('click', function () { $('[data-offer-main]', offer).src = b.getAttribute('data-src'); $$('[data-offer-img]', offer).forEach(function (o) { o.classList.toggle('on', o === b); }); });
    });
    $$('[data-offer-step]', offer).forEach(function (b) {
      b.addEventListener('click', function () {
        var all = $$('[data-offer-img]', offer), i = all.findIndex(function (o) { return o.classList.contains('on'); });
        all[(i + +b.getAttribute('data-offer-step') + all.length) % all.length].click();
      });
    });
    var done = function (take) {
      clearInterval(offerTimer);
      var next = function () { offer.classList.remove('open'); setTimeout(function () { offer.hidden = true; openLayer('cart'); }, 220); };
      if (take) addVariant(offer.getAttribute('data-variant'), 1).then(next, next); else next();
    };
    $('[data-offer-yes]', offer).addEventListener('click', function () { done(true); });
    $$('[data-offer-no]', offer).forEach(function (b) { b.addEventListener('click', function () { done(false); }); });
  }

  /* sticky add-to-bag once the main button scrolls away */
  var main = $('[data-atc-main]'), bar = $('[data-sticky]');
  if (main && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (x) { bar.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.top < 0); });
    }).observe(main);
  }
})();
